import { CDK_ACCORDION, CdkAccordion } from '@angular/cdk/accordion';
import {
  ChangeDetectionStrategy,
  Component,
  input,
  OnDestroy,
} from '@angular/core';
import { AccordionStyling, SS_ACCORDION_STYLING } from './accordion-style';

@Component({
  selector: 'ss-accordion',
  styles: [
    `
      :host {
        display: block;
      }
      cdk-accordion {
        display: block;
      }
    `,
  ],
  template: `<ng-content></ng-content>`,
  providers: [
    {
      provide: CDK_ACCORDION,
      useExisting: AccordionComponent,
    },
    {
      provide: SS_ACCORDION_STYLING,
      useFactory: (component: AccordionComponent) => component.styling(),
      deps: [AccordionComponent],
    },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccordionComponent extends CdkAccordion implements OnDestroy {
  styling = input<AccordionStyling>('faqs');
}
